module.exports = __webpack_public_path__ + "img/mr-chow.bd54dcaf.jpg";